/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { close } from "../assets/close";
import { Icon, type IconBaseProps } from "../icon";

export const IconClose = (props: IconBaseProps) => <Icon {...props} svg={close} />;

IconClose.displayName = "IconClose";
